import { Person } from '@/types/person';

const isEligibleForSelfScheduledIntake = (person: Person): boolean => {
  return person.classifications.includes('eligible_for_self_schedule_intake');
};

export default isEligibleForSelfScheduledIntake;
